import T from '../../common/components/T';
import { API_SERVER_URL } from '../../common/utils/utils';

export const getFormFields = (formData, setFormData, paymasterModal) => {
    return [
        {
            attribute: 'currency',
            type: 'input',
            disabled: true,
            value: formData?.currency,
            title: {
                body: <T textName='currency' defaultStr='Валюта' />
            }
        },
        {
            attribute: 'payment_type',
            type: 'radio-list',
            options: [
                {
                    id: 'single_wallet',
                    title: <T textName='single_wallet' defaultStr='На один кошелёк' />
                },
                {
                    id: 'multiple_wallet',
                    title: <T textName='multiple_wallet' defaultStr='Дробная' />,
                    disabled: formData?.is_one_account
                }
            ],
            value: formData?.payment_type
        },
        {
            attribute: 'accounts',
            type: 'select',
            title: {
                body: <T textName='wallet' defaultStr='Кошелёк' />
            },
            disabled: !formData?.currency || formData?.is_one_account,
            isClear: true,
            getOptions: {
                url: paymasterModal?.order?.currency?.id
                    ? `${API_SERVER_URL}/api/v1/work-table/accounts/in?filter[finance_currency_id]=${paymasterModal?.order?.currency?.id}`
                    : '',
                searchUrl: paymasterModal?.order?.currency?.id
                    ? `${API_SERVER_URL}/api/v1/work-table/accounts/in?filter[finance_currency_id]=${paymasterModal?.order?.currency?.id}`
                    : '',
                sorter: (data) => {
                    const transformed = data?.map((account) => ({
                        title: account?.name + ' / ' + account?.balance_formatted,
                        id: account?.id,
                        max_amount: account?.balance
                    }));
                    if (transformed?.length <= 1) {
                        setFormData((s) => ({
                            ...s,
                            accounts: transformed?.length
                                ? [{ ...transformed[0], amount: +paymasterModal?.order?.payment_amount }]
                                : [],
                            is_one_account: true
                        }));
                    }
                    return transformed;
                },
                preparedLoad: true
            },
            ...(formData?.payment_type === 0
                ? {
                      type: 'select',
                      value: formData?.accounts?.[0]
                  }
                : {
                      type: 'dropdown-multiselect',
                      value: formData?.accounts
                  })
        },
        {
            attribute: 'total_amount',
            type: 'input',
            title: {
                body: <T textName='total_amount' defaultStr='Общая сумма' />
            },
            disabled: true,
            value: paymasterModal?.order?.payment_amount_formatted
        },
        ...(formData?.payment_type === 1
            ? [
                  ...(Array.isArray(formData?.accounts)
                      ? formData?.accounts?.map((account) => {
                            return {
                                attribute: `account-amount_${account.id}`,
                                type: 'input',
                                title: {
                                    body: account.title
                                },
                                value: account?.amount,
                                typeField: 'number'
                            };
                        })
                      : [])
              ]
            : [])
    ];
};

export const setFormDataFunc = (k, v, setFormData, paymasterModal) => {
    setFormData((s) => {
        if (k === 'accounts' && !Array.isArray(v)) {
            return {
                ...s,
                [k]: v ? [{ ...v, amount: +paymasterModal?.order?.payment_amount }] : null
            };
        }
        if (k === 'accounts') {
            return {
                ...s,
                [k]: s?.accounts?.length
                    ? v?.map((account) => {
                          const findedAmount = s?.accounts?.find((acc) => +acc?.id === +account?.id)?.amount;
                          if (findedAmount) {
                              return {
                                  ...account,
                                  amount: findedAmount
                              };
                          }
                          return account;
                      })
                    : v
            };
        }
        if (k.split('_')[0] === 'account-amount') {
            return {
                ...s,
                ['accounts']: s?.accounts?.map((acc) => {
                    if (+acc?.id === +k?.split('_')[1]) {
                        return {
                            ...acc,
                            amount: v
                        };
                    }
                    return acc;
                })
            };
        }
        if (k === 'payment_type') {
            return {
                ...s,
                [k]: v,
                accounts: []
            };
        }
        return {
            ...s,
            [k]: v
        };
    });
};
